require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-y-y-0-wn.json") })
        }
      }, "path---photos-professional-y-y-0-wn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-y-y-0-wn!./.cache/json/photos-professional-y-y-0-wn.json
// module id = 956
// module chunks = 231608221292675